import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export default function ConfirmInvite() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: 'loading', name: '', email: '', error: '' });

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setState({ status: 'error', error: 'Missing confirmation token.' });
      return;
    }
    axios.post(`${API}/family/confirm`, { token })
      .then((r) => setState({ status: 'success', name: r.data.invitee_name, email: r.data.invitee_email }))
      .catch((e) => setState({ status: 'error', error: e.response?.data?.detail || 'Confirmation failed. Please try again.' }));
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 p-4">
      <div className="glass-card max-w-md w-full p-8 text-center" data-testid="confirm-invite-card">
        {state.status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 mx-auto animate-spin text-blue-400" />
            <p className="text-white mt-4 font-semibold">Confirming your invite...</p>
          </>
        )}
        {state.status === 'success' && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-green-400" />
            <h1 className="text-2xl font-bold text-white mt-4">Member Added!</h1>
            <p className="text-slate-300 mt-2" data-testid="confirm-invite-success">
              <strong>{state.name}</strong> has been added to your account. An email was sent to{' '}
              <strong>{state.email}</strong> with a link to set their password.
            </p>
          </>
        )}
        {state.status === 'error' && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-red-400" />
            <h1 className="text-2xl font-bold text-white mt-4">Confirmation Failed</h1>
            <p className="text-slate-300 mt-2" data-testid="confirm-invite-error">{state.error}</p>
          </>
        )}
        {state.status !== 'loading' && (
          <Button
            onClick={() => navigate('/')}
            className="mt-6 bg-gradient-to-r from-blue-500 to-blue-600"
            data-testid="confirm-invite-home-btn"
          >
            Back to App
          </Button>
        )}
      </div>
    </div>
  );
}
